<div class="sidebar flex h-full shrink-0 select-none relative">
  <div
    class="sidebar-primary-rail flex flex-col shrink-0 h-full transition-all duration-300 ease-in-out"
    [style.width]="isCollapsed() ? '72px' : '220px'"
  >
    <!-- Logo -->
    <div
      class="shrink-0 flex items-center pt-4 pb-3 px-2"
      [class.justify-center]="isCollapsed()"
      [class.justify-between]="!isCollapsed()"
    >
      <button
        type="button"
        class="w-10 h-10 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0 shadow-sm transition-transform hover:scale-[1.02] cursor-pointer"
        style="background: var(--primary)"
        [title]="isCollapsed() ? 'Expand sidebar' : 'IDP'"
        (click)="isCollapsed() ? toggleCollapse.emit() : null"
      >
        IDP
      </button>
      @if (!isMobile() && !isCollapsed()) {
        <button
          type="button"
          class="w-8 h-8 rounded-lg flex items-center justify-center transition-all hover:opacity-85 cursor-pointer sidebar-rail-btn"
          title="Collapse sidebar"
          (click)="toggleCollapse.emit()"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      }
    </div>

    <!-- Primary nav -->
    <div
      class="flex flex-col gap-1 flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-2"
      [class.items-center]="isCollapsed()"
    >
      @for (item of primaryItems; track item.id) {
        <button
          type="button"
          class="sidebar-rail-btn relative flex items-center rounded-xl text-left cursor-pointer"
          [class.sidebar-rail-btn--active]="activePrimary() === item.id"
          [class.w-11]="isCollapsed()"
          [class.h-11]="isCollapsed()"
          [class.justify-center]="isCollapsed()"
          [class.w-full]="!isCollapsed()"
          [class.gap-3]="!isCollapsed()"
          [class.px-3]="!isCollapsed()"
          [class.py-2.5]="!isCollapsed()"
          [title]="item.label"
          (click)="selectPrimary(item)"
        >
          <svg
            class="w-5 h-5 shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            stroke-width="1.75"
          >
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="item.icon" />
          </svg>
          <span
            class="sidebar-item-label text-[13px] leading-tight truncate flex-1 min-w-0"
            [class.sidebar-item-label-collapsed]="isCollapsed()"
            [style.font-weight]="activePrimary() === item.id ? '600' : '500'"
          >{{ item.label }}</span>
        </button>
      }
    </div>

    <!-- Bottom: profile + logout -->
    <div
      class="flex flex-col gap-1.5 pb-4 pt-3 border-t shrink-0 px-2"
      style="border-color: var(--sidebar-border)"
      [class.items-center]="isCollapsed()"
    >
      <div
        class="sidebar-rail-btn flex items-center rounded-xl"
        [class.w-11]="isCollapsed()"
        [class.h-11]="isCollapsed()"
        [class.justify-center]="isCollapsed()"
        [class.w-full]="!isCollapsed()"
        [class.gap-3]="!isCollapsed()"
        [class.px-3]="!isCollapsed()"
        [class.py-2]="!isCollapsed()"
        title="Admin"
      >
        <div
          class="w-9 h-9 rounded-full flex items-center justify-center text-white text-[11px] font-bold shrink-0"
          style="background: var(--primary)"
        >
          {{ userInitials() }}
        </div>
        @if (!isCollapsed()) {
          <span class="text-[13px] truncate flex-1 min-w-0" style="color: var(--sidebar-text)">
            {{ userDisplayName() }}
          </span>
        }
      </div>

      <button
        type="button"
        class="sidebar-rail-btn flex items-center rounded-xl cursor-pointer"
        [class.w-11]="isCollapsed()"
        [class.h-11]="isCollapsed()"
        [class.justify-center]="isCollapsed()"
        [class.w-full]="!isCollapsed()"
        [class.gap-3]="!isCollapsed()"
        [class.px-3]="!isCollapsed()"
        [class.py-2.5]="!isCollapsed()"
        title="Sign out"
        (click)="logout()"
      >
        <svg
          class="w-5 h-5 shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          stroke-width="1.75"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1"
          />
        </svg>
        @if (!isCollapsed()) {
          <span class="text-[13px] font-medium" style="color: var(--sidebar-text)">Sign out</span>
        }
      </button>
    </div>
  </div>
</div>
